import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons"
import { useNavigate } from 'react-router-dom'
import { useGetHepQuery } from './hepApiSlice'
import { memo } from 'react'

const Hep = ({ hepId, isMobile }) => {

    const { hep } = useGetHepQuery("hepList", {
        selectFromResult: ({ data }) => ({
            hep: data?.entities[hepId]
        }),
    })

    const navigate = useNavigate()

    if (hep) {
        const created = new Date(hep.createdAt).toLocaleString('en-US', { day: 'numeric', month: 'long' })

        const updated = new Date(hep.updatedAt).toLocaleString('en-US', { day: 'numeric', month: 'long' })

        const handleEdit = () => navigate(`/dash/hep/${hepId}`)

        const editButton= (
            <span
                className="text-steel"
                role="button"
                onClick={handleEdit}
            >
                <FontAwesomeIcon icon={faPenToSquare}  className="fa-icon"/>
            </span>
        )

        return (
            <tr>
                { isMobile === false && <td>{created}</td>}
                { isMobile === false && <td>{updated}</td>}
                <td>{hep.title}</td>
                <td>{hep.username}</td>
                <td>{editButton}</td>
            </tr>
        )

    } else return null
}

const memoizedNote = memo(Hep)

export default memoizedNote